export enum AnalyticsEventName {
    AddToCart = 'add_to_cart',
    Purchase = 'purchase',
    ViewItemList = 'view_item_list',
    SelectItem = 'select_item',
    ViewItem = 'view_item',
    BeginCheckout = 'begin_checkout',
    AddToWishlist = 'add_to_wishlist',
    AddShippingInfo = 'add_shipping_info',
    AddPaymentInfo = 'add_payment_info',
    RemoveFromCart = 'remove_from_cart',
    ManageInterestsSave = 'manage_interests_save',
    NewsletterDoubleOptIn = 'newsletter_double_optin',
    PWAInstalled = 'pwa_installed',
    PWABannerDismissed = 'pwa_banner_dismissed',
    PWABannerShown = 'pwa_banner_shown',
    PWABannerClick = 'pwa_banner_click',
    PushNotificationShown = 'push_notification_banner_shown',
    PushNotificationSubscription = 'push_notification_subscription',
    SearchResults = 'view_search_results',
    PageView = 'page_view',
}
